(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('AuthServerProvider', AuthServerProvider);

  AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q', 'API_URI'];

  function AuthServerProvider($http, $localStorage, $sessionStorage, $q, API_URI) {
    var service = {
      getToken: getToken,
      login: login,
      loginWithToken: loginWithToken,
      storeAuthenticationToken: storeAuthenticationToken,
      logout: logout
    };

    return service;

    function getToken() {
      return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
    }

    function login(credentials) {

      var data = {
        username: credentials.username,
        password: credentials.password,
        rememberMe: credentials.rememberMe
      };
      return $http.post(API_URI + 'api/authenticate', data).then(authenticateSuccess);

      function authenticateSuccess(response) {
        var bearerToken = response.headers('Authorization');
        if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
          var jwt = bearerToken.slice(7, bearerToken.length);
          service.storeAuthenticationToken(jwt, credentials.rememberMe);
          return jwt;
        }
      }
    }

    function loginWithToken(jwt, rememberMe) {
      var deferred = $q.defer();

      if (angular.isDefined(jwt)) {
        this.storeAuthenticationToken(jwt, rememberMe);
        deferred.resolve(jwt);
      } else {
        deferred.reject();
      }

      return deferred.promise;
    }

    function storeAuthenticationToken(jwt, rememberMe) {
      if (rememberMe || true) { //keep always auth between sessions
        $localStorage.authenticationToken = jwt;
      } else {
        $sessionStorage.authenticationToken = jwt;
      }
    }

    function logout() {
      delete $localStorage.authenticationToken;
      delete $sessionStorage.authenticationToken;
    }
  }
})();
